import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import DividasListar from '../../components/divida/listar';


function DividasScreen () {
    return (
        <Fragment>
            <Head titulo="Listagem de empresas e pessoas com Dívidas Ativas com o Município de Macuco"/>
            <Header />
            <Container>
                <DividasListar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default DividasScreen;